module.exports = __webpack_public_path__ + "static/media/vertiente-de-agua-2.316c8b52.jpg";